export { Community as default } from '@/features/inquiry-library';
